import {useContext} from "react"
import {AppContext} from "../contexts/AppContextProvider"
import http from "../http"
import EmailLogRequest from "../types/interface/EmailLogRequest"
import StackTrace from "stacktrace-js";

const useLogger = () => {

    const {complaint, customer, loggedIn} = useContext(AppContext)


    return {
        email: async (message: 'logged from Nature of Complaint' | 'logged from guest Form' | 'logged from Complaint Completion') => {
            if (loggedIn) {
                let body: EmailLogRequest = {
                    email: customer.emailAddress || complaint.shippingInfo.customer?.emailAddress as string,
                    customerNumber: customer.customer,
                    userType: "SSO",
                    message: message
                }

                await http.post('api/Client/LogEmail', body)
            } else {
                let body: EmailLogRequest = {
                    email: customer.emailAddress || complaint.shippingInfo.customer?.emailAddress as string,
                    customerNumber: complaint.guestInfo.customerNumber,
                    userType: "GuestUser",
                    message: message
                }

                await http.post('api/Client/LogEmail', body)
            }
        },
        error: async (
            err: Error,
            customerNumber: string = customer.customer || complaint.guestInfo.customerNumber || 'not available',
            email: string = customer.emailAddress || complaint.shippingInfo.customer?.emailAddress || 'not available'
        ) => {

            let stackTrace = ''
            let message = ''

            if (err) {
                const stack = await StackTrace.fromError(err)
                stackTrace = stack.map(s => s.toString()).join('\n\t\t')
                message = err.message
                console.error(message, stack)
            }

            await http.post('api/Client/LogError', {
                customerNumber,
                email,
                message,
                stackTrace,
            })
        }
    }
}

export default useLogger